import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ArrowLeft, MessageCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactoPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    mensaje: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.nombre || !formData.email || !formData.mensaje) {
      toast.error("Por favor completa todos los campos requeridos");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API}/contacto`, formData);
      toast.success("¡Mensaje enviado exitosamente! Nos pondremos en contacto contigo pronto.");
      setFormData({ nombre: "", email: "", telefono: "", mensaje: "" });
    } catch (error) {
      console.error("Error enviando mensaje:", error);
      toast.error("Error al enviar el mensaje. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-warm-bone py-12">
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-4xl">
        <Button
          onClick={() => navigate("/")}
          variant="ghost"
          className="mb-8"
          data-testid="back-button"
        >
          <ArrowLeft className="mr-2" size={20} />
          Volver al Inicio
        </Button>

        <div className="glass-card rounded-3xl p-8 md:p-12">
          <div className="flex items-center gap-4 mb-6">
            <MessageCircle className="h-12 w-12 text-zuno-wine" />
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-zuno-wine">
                Contáctanos
              </h1>
              <p className="text-lg text-slate-600 mt-2">
                ¿Tienes alguna pregunta o comentario? Escríbenos
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6 mt-8">
            <div>
              <Label htmlFor="nombre">Nombre Completo *</Label>
              <Input
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                placeholder="Tu nombre"
                required
                data-testid="input-nombre"
              />
            </div>

            <div>
              <Label htmlFor="email">Correo Electrónico *</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="correo@ejemplo.com"
                required
                data-testid="input-email"
              />
            </div>

            <div>
              <Label htmlFor="telefono">Teléfono</Label>
              <Input
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                placeholder="33-1234-5678"
                data-testid="input-telefono"
              />
            </div>

            <div>
              <Label htmlFor="mensaje">Mensaje o Pregunta *</Label>
              <Textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                placeholder="Escribe tu mensaje aquí..."
                rows={6}
                required
                data-testid="input-mensaje"
              />
            </div>

            <Button
              type="submit"
              className="w-full btn-primary text-xl py-6"
              disabled={loading}
              data-testid="submit-button"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 animate-spin" />
                  Enviando...
                </>
              ) : (
                <>
                  <MessageCircle className="mr-2" />
                  Enviar Mensaje
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactoPage;
